import Component from "./Component.js"
import Utils from "./Utils.js"

export default class Ads extends Component {

  constructor(props, context) {
    super(props, context)
    this.classList.add("amp-ads", true)
    this.state.msg = ""
    this.state.time = ""
    this.bindHandlers(["onadbreakstart", "onadbreakend", "onadstarted", "onadtimeremaining", "onadimpression"])
  }

  static get contextTypes() {
    return super.contextTypes
  }

  get container() {
    return this.refs.container
  }

  onready(event) {
    this.controlsMode = this.plugin.mode
    this.player.addEventListener("adbreakstart", this.onadbreakstart)
    this.player.addEventListener("adbreakend", this.onadbreakend)
    this.player.addEventListener("adstarted", this.onadstarted)
    this.player.addEventListener("adtimeremaining", this.onadtimeremaining)
    this.player.addEventListener("adimpression", this.onadimpression)
  }

  onmediachange(event) {
    this.onadbreakend()
  }

  onadimpression(event) {
    //this.plugin.container.classList.update({"amp-ad-overlaymode": true})
    this.player.ads.resize()
  }

  onadbreakstart(event) {
    this.plugin.container.classList.update({"amp-ad-break": true})
    this.player.container.classList.add("amp-ad-break")
    const adVO = event.detail
    this.setState({msg: "", time: ""})
    this.controlsMode = this.plugin.mode
    this.plugin.mode = this.plugin.adMode
  }

  onadstarted(event) {
    const adVO = event.detail || {}
    const msg = (adVO.position == null || adVO.totalAds == null) ? "" : `${this.getLocalizedString("MSG_AD")} ${adVO.position} ${this.getLocalizedString("MSG_OF")} ${adVO.totalAds}`
    this.setState({time: adVO.duration, msg})
  }

  onadbreakend(event) {
    this.setState({msg: "", time: ""})
    this.plugin.container.classList.update({"amp-ad-break": false})
    this.player.container.classList.remove("amp-ad-break")
    this.plugin.mode = this.controlsMode
  }

  onadtimeremaining(event) {
  	if (this.player.playState == "ready")
  	  return
    this.setState({time: event.detail})
  }

  render() {
    const time = (this.state.time != "") ? Utils.formatTimecode(Math.ceil(this.state.time)) : this.state.time

    return (
      <div ref="containerNode" className="amp-ads">
        <div ref="container" className="amp-ad-container" />
        <div className="amp-bar amp-ad-info">
          <div ref="count" className="amp-ad-component amp-ad-count">{this.state.msg}</div>
          <div ref="spacerLeft" className="amp-spacer" />
          <div ref="spacerRight" className="amp-spacer" />
          <div ref="time" className="amp-ad-component amp-ad-time">{time}</div>
        </div>
      </div>
    )
  }
}
